module.exports = __webpack_public_path__ + "media/icons/icon-activities-success-green-693a5254.svg";